import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { ArrowDown2Icon, ArrowUp2Icon } from '@root/shared/ui-kit'

type Props = {
  assetsNumber: number
  onExpandToggle: () => void
  expanded: boolean
}

export const WalletsAssetsCell: React.FC<Props> = ({
  assetsNumber,
  onExpandToggle,
  expanded,
}) => {
  const { t } = useTranslation()
  return (
    <Root
      type="button"
      variant="secondary"
      size="h32"
      radius="rounded"
      onClick={(e) => {
        e.stopPropagation()
        onExpandToggle()
      }}
      data-expanded={expanded}
      iconRight={expanded ? <ArrowUp2Icon /> : <ArrowDown2Icon />}
    >
      {assetsNumber} {t('asset', { count: assetsNumber })}
    </Root>
  )
}

const Root = styled(Button)`
  &[data-expanded='true'] {
    background: var(--background-1);
    border-color: var(--background-1);
  }
`
